export const chunkString = (str, size) => {
  const numChunks = Math.ceil(str.length / size)
  const chunks = ['']

  for (let i = 0, o = 0; i < numChunks; ++i, o += size) {
    chunks[i] = str.substr(o, size)
  }

  return chunks;
}